<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Platform | Reset Password</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
    </Head>
    <!-- main content-->
    <section class="relative flex justify-center items-center h-screen px-2">
      <!-- decoration -->
      <div class="absolute left-0 w-2/4 z-0">
        <img
          :src="$filters.public_path('/login-dec-left.svg')"
          alt="lines decoration"
          draggable="false"
        />
      </div>
      <div class="absolute right-0">
        <img
          :src="$filters.public_path('/login-dec-right.svg')"
          alt="lines decoration"
          draggable="false"
        />
      </div>
      <!-- form start -->
      <div class="z-20 max-w-[800px] w-full m-auto rounded-lg">
        <!-- logo -->
        <div class="pb-16">
          <Link href="/">
            <img
              :src="$filters.media_path('images/platforma-logo-in-color.svg')"
              alt="Platforma logo"
              class="m-auto w-full max-w-[400px]"
              draggable="false"
            />
          </Link>
        </div>
        <!-- form card -->
        <div
          class="z-20 w-full m-auto p-5 md:p-28 rounded-lg shadow-2xl shadow-blue-400 bg-white"
          v-if="!isLoading['success']"
        >
          <!-- heading -->
          <h1 class="text-3xl text-gray-700 pb-6 text-center">
            Password Recovery
          </h1>
          <h3 class="text-xl text-gray-500 pb-10 text-center">
            Enter your email and we'll send you a link to reset your password.
          </h3>
          <!-- form start -->
          <Form
            @submit="handleSubmit"
            :validation-schema="schema"
            v-slot="{ errors }"
          >
            <!-- email -->
            <div
              class="mb-10"
              :class="{
                'form-error': errors.email,
                'form-success': !errors.email
              }"
            >
              <Field
                as="input"
                name="email"
                type="text"
                v-model="email"
                class="border border-gray-400 text-gray-900 text-md rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                placeholder="Enter email..."
              />
              <ErrorMessage name="email" class="text-red-400" />
            </div>
            <!-- login -->
            <div class="flex justify-center mb-6">
              <Link href="/login">
                <p
                  for="remember"
                  class="ml-2 text-sm cursor-pointer font-medium text-blue-500 hover:text-blue-300 transition duration-150 ease-out hover:ease-in"
                >
                  Try Login Again?
                </p>
              </Link>
            </div>
            <!-- backend error -->
            <div class="py-2" v-if="backEndError">
              <p class="text-red-400 text-center">
                {{ backEndError[0] }}
              </p>
            </div>
            <!-- action -->
            <div class="text-center">
              <button
                :disabled="isLoading['submit']"
                type="submit"
                class="text-xl text-center text-white bg-blue-500 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full w-2/3 px-15 py-4 transition duration-150 ease-out hover:ease-in"
              >
                <LoaderComponent
                  :isReactive="isLoading['submit']"
                ></LoaderComponent>
                {{ isLoading['submit'] ? '' : 'Recover' }}
              </button>
            </div>
          </Form>
        </div>
        <!-- success submission -->
        <div
          v-else
          class="z-20 w-full m-auto p-5 md:p-28 rounded-lg shadow-2xl shadow-blue-400 bg-white"
        >
          <h1 class="text-center">We have emailed your password reset link!</h1>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import Axios from 'axios';
import LoaderComponent from '../../../shareComponents/js/Components/LoaderComponent.vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
// import { Inertia } from '@inertiajs/inertia';

const email = ref('');
const backEndError = ref('');
const isLoading = reactive({});

const schema = yup.object({
  email: yup.string().required('Please provide an email').email()
});

const handleSubmit = async () => {
  isLoading['submit'] = true;
  // isLoading['error'] = false;

  Axios.post('/creator/password/email', {
    email: email.value
  })
    .then((res) => {
      // console.log(res.data);
      if (res.data.code === 0) {
        backEndError.value = res.data.errors;
        isLoading['submit'] = false;
      } else {
        isLoading['submit'] = false;
        isLoading['success'] = true;
      }
    })
    .catch((err) => {
      console.log(err);
      isLoading['submit'] = false;
      // isLoading['error'] = true;
    });
};

onMounted(() => {
  isLoading['success'] = false;
  isLoading['error'] = false;
});
</script>

<style>
.form-error input {
  border-color: red !important;
}

.form-error input::placeholder {
  color: red !important;
}
</style>
